export default "__VITE_ASSET__B632UVKI__"